import React, { useState } from "react";
import { Popover } from "antd";
import { SketchPicker } from "react-color";
import { Editor } from "slate";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";

export const ColorButton = ({ editor, format, background = false, disabled }) => {
  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(background ? "#ffe58f" : "#1677ff");
  const handleChange = (newColor) => {
    setColor(newColor.hex);
    Editor.addMark(editor, background ? "backgroundColor" : "color", newColor.hex);
  };

  const currentMark = Editor.marks(editor)?.[background ? "backgroundColor" : "color"];
  const isActive = !!currentMark;

  return (
    <Popover
      content={<SketchPicker color={color} onChangeComplete={handleChange} />}
      trigger="click"
      open={visible}
      onOpenChange={setVisible}
    >
      <KoButton
        type="text"
        disabled={disabled}
        iconBtn
        active={isActive}
        icon={background ?  <KoIcon width={20} height={20} name="BgColorOutlined" /> :  <KoIcon width={20} height={20} name="TextColorOutlined" />}
        onMouseDown={(e) => e.preventDefault()}
      />
       
    </Popover>
  );
};
